import { event } from '@/api'
import {
	AGENDA_EVENT_GET,
	ATTENDEES_EVENT_GET,
	EVENT_GET,
	EVENT_GET_ERROR,
	EVENT_LOADING_STATUS,
	EVENTS_FETCH,
	EVENTS_FETCH_ERROR,
	PARTNERS_EVENT_GET,
	EVENTS_FETCH_CATEGORIES,
	EVENTS_FETCH_CATEGORIES_ERROR,
	REMOVE_ATTENDEES_EVENT,
	ATTENDEE_EVENT_GET,
	ATTENDEES_EVENT_CLEAR,
	SESSION_EVENT_GET,
	SESSION_EVENT_CLEAR,
	SESSION_EVENT_QUESTIONS_GET,
	EVENTS_CLEAR,
	EVENT_LOADING_CATEGORIES_STATUS,
	EVENT_GET_TRACKS,
	EVENT_TRACKS_LOADING_STATUS,
	EVENT_CLEAR_TRACKS,
	GET_ACTION_FILES,
	GET_ACTION_LINKS,
	EVENT_MY_AGENDA_LOADING_STATUS,
	EVENT_AGENDA_UPDATE_ITEM,
	EVENT_POLLS_LOADING_STATUS,
	UPDATE_EVENT_POLLS,
	EVENT_RATINGS_LOADING_STATUS,
	UPDATE_EVENT_RATINGS,
	UPDATE_SESSION_RATINGS,
	EVENT_SPEAKERS_GET,
	EVENT_SPEAKERS_CLEAR,
	EVENT_GET_EXHIBITOR,
	GET_BOOT_STAFF_LIST,
	BOOT_STAFF_LOADING_STATUS,
	SET_FOLLOW_STATUS,
	SET_FOLLOW_NOTE,
	POST_EVENT_SESSIONS_REGISTER,
	POST_EVENT_SESSIONS_REGISTER_LOADING,
	DELETE_EVENTS_SESSIONS_REGISTER,
	EVENT_GET_EXHIBITOR_ERROR,
	EVENT_CLEAR_EXHIBITOR,
	EVENT_PRIVATE_LOADING,
	GET_SUB_SESSIONS,
	GET_SUB_SESSIONS_LOADING,
	GET_SUB_SESSIONS_ERROR,
	GET_SESSIONS_SPEAKERS_LIST,
	GET_SESSIONS_SPEAKERS_LIST_LOADING,
	GET_SESSIONS_SPEAKERS_LIST_ERROR,
	SESSION_EVENT_DELETE_LOADING,
	GET_SURVEY,
	GET_SURVEY_LOADING,
	GET_SURVEY_ERROR,
	POST_SURVEY_CLASSIC_LOADING,
	POST_SURVEY_CLASSIC_ERROR,
    GET_PARTNER_FILES,
    GET_PARTNER_FILES_LOADING,
    GET_PARTNER_FILES_ERROR,
    GET_GIVEAWAYS,
    GET_GIVEAWAYS_LOADING,
    GET_GIVEAWAYS_ERROR,
    GET_GIVEAWAYS_ERROR_CLEAR
} from '@/store/event/types'

const getGiveaways = async (ctx, query = '') => {
    ctx.commit(GET_GIVEAWAYS_LOADING, true)
    try {
        const {data,headers} = await event.getGiveaways(query)
        const pageCount = headers['x-pagination-page-count']
        const response = { data, pageCount }
        ctx.commit(GET_GIVEAWAYS,response)
        ctx.commit(GET_GIVEAWAYS_LOADING, false)
    } catch (e){
        console.error(e)
        ctx.commit(GET_GIVEAWAYS_ERROR, e)
    } finally {
        ctx.commit(GET_GIVEAWAYS_LOADING, false)
    }
}

const getPartnerFiles = async (ctx, query = '') => {
    ctx.commit(GET_PARTNER_FILES_LOADING, true)
    try {
        const {data,headers} = await event.getPartnerFiles(query)
        const pageCount = headers['x-pagination-page-count']
        const response = { data, pageCount }
        ctx.commit(GET_PARTNER_FILES,response)
        ctx.commit(GET_PARTNER_FILES_LOADING, false)
    } catch (e){
        console.error(e)
        ctx.commit(GET_PARTNER_FILES_ERROR, e)
    } finally {
        ctx.commit(GET_PARTNER_FILES_LOADING, false)
    }
}

const postBackStep = async (ctx, { id, data }) => {
	ctx.commit(POST_SURVEY_CLASSIC_LOADING, true)
	try {
		await event.backStep(id, data)
	} catch (e) {
		console.error(e)
		ctx.commit(POST_SURVEY_CLASSIC_ERROR, e)
	} finally {
		ctx.commit(POST_SURVEY_CLASSIC_LOADING, false)
	}
}

const postNextStep = async (ctx, { id, data }) => {
	ctx.commit(POST_SURVEY_CLASSIC_LOADING, true)
	try {
		await event.nextStep(id, data)
	} catch (e) {
		console.error(e)
		ctx.commit(POST_SURVEY_CLASSIC_ERROR, e)
	} finally {
		ctx.commit(POST_SURVEY_CLASSIC_LOADING, false)
	}
}

const postSurvey = async (ctx, { id, data, isQuiz = false }) => {
	ctx.commit(POST_SURVEY_CLASSIC_LOADING, true)
	try {
		const mode = isQuiz ? 'quiz' : 'classic'
		await event.postSurvey(id, data, mode)
	} catch (e) {
		console.error(e)
		ctx.commit(POST_SURVEY_CLASSIC_ERROR, e)
	} finally {
		ctx.commit(POST_SURVEY_CLASSIC_LOADING, false)
	}
}

const getEventSurvey = async (ctx, { id, type }) => {
	ctx.commit(GET_SURVEY_LOADING, true)
	try {
		const { data } = await event.getSurvey(id, type)
		ctx.commit(GET_SURVEY, data)
	} catch (e) {
		console.error(e)
		ctx.commit(GET_SURVEY_ERROR, e)
	} finally {
		ctx.commit(GET_SURVEY_LOADING, false)
	}
}
const getSurveyErrorClear = async (ctx) => {
    try {
        ctx.commit(GET_SURVEY_ERROR, null)
    } catch (e){
        console.error(e)
    }
}

const deleteSessionQuestion = async (ctx, id) => {
	ctx.commit(SESSION_EVENT_DELETE_LOADING, true)
	try {
		await event.deleteSessionQuestion(id)
		ctx.commit(SESSION_EVENT_DELETE_LOADING, false)
	} catch (e) {
		console.error(e)
		ctx.commit(SESSION_EVENT_DELETE_LOADING, false)
	}
}

const deleteRegisterSessions = async (ctx, id, deleteRegister) => {
	ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, true)
	try {
		const { data } = await event.deleteRegisterEventSession(id, deleteRegister)
		ctx.commit(DELETE_EVENTS_SESSIONS_REGISTER, data)
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
	} catch (e) {
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
		console.log(e)
		throw e
	}
}

const postRegisterSession = async (ctx, sessionRegister) => {
	ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, true)
	try {
		const { data } = await event.postRegisterEventSession(sessionRegister)
		ctx.commit(POST_EVENT_SESSIONS_REGISTER, data)
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
	} catch (e) {
		ctx.commit(POST_EVENT_SESSIONS_REGISTER_LOADING, false)
		console.log(e)
		throw e
	}
}

const getBoothStaff = async (ctx, query = '') => {
	ctx.commit(BOOT_STAFF_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getBoothStaffList(query)
		const pageCount = headers['x-pagination-page-count']
		const totalCount = headers['x-pagination-total-count']
		const response = { data, pageCount, totalCount }

		ctx.commit(GET_BOOT_STAFF_LIST, response)
		ctx.commit(BOOT_STAFF_LOADING_STATUS, false)
	} catch (e) {
		console.error(e)
	}
}

const toggleBookmark = async (
	{ commit },
	{ user_id, bookmark_entity_type, bookmark_entity_id, created_at, bookmark_status }
) => {
	try {
		const { data } = await event.putExhibitorPartnersFollow({
			user_id,
			bookmark_entity_type,
			bookmark_entity_id,
			created_at,
			bookmark_status,
		})
		commit(SET_FOLLOW_STATUS, data)
	} catch (e) {
		console.log(e)
		throw e
	}
}
const saveFollowNote = async (
	{ commit },
	{ bookmark_note, user_id, bookmark_entity_type, bookmark_entity_id, created_at }
) => {
	try {
		const { data } = await event.putExhibitorPartnersFollow({
			bookmark_note,
			user_id,
			bookmark_entity_type,
			bookmark_entity_id,
			created_at,
		})
		commit(SET_FOLLOW_NOTE, data)
	} catch (e) {
		console.log(e)
		throw e
	}
}

const fetchEvents = async (ctx, filters) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.fetchEvents(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(EVENTS_FETCH, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const fetchEventCategories = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_CATEGORIES_STATUS, true)
	try {
		const { data, headers } = await event.fetchEventCategories(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(EVENTS_FETCH_CATEGORIES, response)
		ctx.commit(EVENT_LOADING_CATEGORIES_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_CATEGORIES_ERROR, e)
		console.error(e)
	}
}

const getEvent = async (ctx, eventId) => {
	ctx.commit(EVENT_LOADING_STATUS, true)

	try {
		const { data } = await event.getEvent(eventId)
		ctx.commit(EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)
		ctx.commit(ATTENDEES_EVENT_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}
const getEventPrivate = async (ctx, eventId) => {
	ctx.commit(EVENT_PRIVATE_LOADING, true)
	try {
		const { data } = await event.getEvent(eventId)
		let newEventView = Array.isArray(data.eventView) ? [...data.eventView] : []
		const prevBlocks = Array.isArray(ctx.state.event.eventView) ? ctx.state.event.eventView : []
		const preservedBlock = prevBlocks.find((b) => b.block_name === 'eventInfo')
		if (preservedBlock) {
			newEventView = newEventView.filter((b) => b.block_name !== 'eventInfo')
			newEventView.unshift(preservedBlock)
		}
		ctx.commit(EVENT_GET, { eventView: newEventView })
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_PRIVATE_LOADING, false)
	}
}

const getAgendaEvent = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getAgendaEvent(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(AGENDA_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}
const getAllSessionsSpeaker = async (ctx, query) => {
	ctx.commit(GET_SESSIONS_SPEAKERS_LIST_LOADING, true)
	try {
		const { data, headers } = await event.getSessionSpeakers(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(GET_SESSIONS_SPEAKERS_LIST, response)
		ctx.commit(GET_SESSIONS_SPEAKERS_LIST_LOADING, false)
	} catch (e) {
		ctx.commit(GET_SESSIONS_SPEAKERS_LIST_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(GET_SESSIONS_SPEAKERS_LIST_LOADING, false)
	}
}

const getSubSessions = async (ctx, query) => {
	ctx.commit(GET_SUB_SESSIONS_LOADING, true)
	try {
		const { data, headers } = await event.getSubSessions(query)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(GET_SUB_SESSIONS, response)
		ctx.commit(GET_SUB_SESSIONS_LOADING, false)
	} catch (e) {
		ctx.commit(GET_SUB_SESSIONS_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(GET_SUB_SESSIONS_LOADING, false)
	}
}

const getAttendeesEvent = async (ctx, query = '') => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getAttendeesEvent(query)

		const pageCount = headers['x-pagination-page-count']
		const totalCount = headers['x-pagination-total-count']
		const response = { data, pageCount, totalCount }

		ctx.commit(ATTENDEES_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getAttendee = async (ctx, id) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.getAttendeeEvent(id)
		ctx.commit(ATTENDEE_EVENT_GET, data)

		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getSession = async (ctx, id) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data } = await event.getEventSession(id)

		ctx.commit(SESSION_EVENT_GET, data)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const clearSession = async (ctx) => {
	try {
		ctx.commit(SESSION_EVENT_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getActionFiles = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getActionFiles(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(GET_ACTION_FILES, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getActionLinks = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getActionLinks(query)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(GET_ACTION_LINKS, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const fetchPartners = async (ctx, filters) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.fetchPartners(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(PARTNERS_EVENT_GET, response)
		ctx.commit(EVENT_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(EVENTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const clearAttendeesEvent = (ctx) => {
	ctx.commit(REMOVE_ATTENDEES_EVENT)
}

const addSessionQuestion = async (
	ctx,
	{ qna_question_text, qna_id, qna_allow_anonymous, user_id, qna_entity_type, qna_entity_id }
) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		await event.addSessionAgendaQuestion({
			qna_question_text,
			qna_id,
			user_id,
            qna_allow_anonymous,
			qna_entity_type,
			qna_entity_id,
		})
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const getSessionQuestions = async (ctx, query) => {
	ctx.commit(EVENT_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getSessionQuestions(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(SESSION_EVENT_QUESTIONS_GET, response)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const upvoteSessionQuestion = async (ctx, { qna_upvote_id, qna_question_id, user_id }) => {
	try {
		await event.upvoteSessionQuestion({
			qna_upvote_id,
			qna_question_id,
			user_id,
		})
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const deleteUpvoteSessionQuestion = async (ctx, id) => {
	try {
		await event.deleteUpvoteSessionQuestion(id)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const clearEventCategories = async (ctx) => {
	try {
		ctx.commit(EVENTS_CLEAR)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const addEventToSchedule = async (ctx, data) => {
	try {
		await event.addToSchedule(data)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const removeEventFromSchedule = async (ctx, id) => {
	try {
		await event.removeFromSchedule(id)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const getEventTracks = async (ctx, eventId) => {
	ctx.commit(EVENT_TRACKS_LOADING_STATUS, true)
	try {
		const { data, headers } = await event.getEventTracks(eventId)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(EVENT_GET_TRACKS, response)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_TRACKS_LOADING_STATUS, false)
	}
}

const clearEventTracks = async (ctx) => {
	try {
		ctx.commit(EVENT_CLEAR_TRACKS)
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	}
}

const addMyAgenda = async (ctx, { id, single }) => {
	try {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: true, id })
		const { data } = await event.addMyAgenda({ agenda_id: id })
		if (single) {
			ctx.commit(SESSION_EVENT_GET, { ...ctx.state.session, is_scheduled: true })
		} else {
			ctx.commit(EVENT_AGENDA_UPDATE_ITEM, { agenda: data.eventsAgenda, id, remove: false })
		}
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: false })
	}
}

const removeMyAgenda = async (ctx, { id, myAgenda, single, filter }) => {
	try {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: true, id })
		const { data } = await event.removeMyAgenda(id)
		if (single) {
			ctx.commit(SESSION_EVENT_GET, { ...ctx.state.session, is_scheduled: false })
		} else {
			ctx.commit(EVENT_AGENDA_UPDATE_ITEM, {
				agenda: data.eventsAgenda,
				id,
				remove: myAgenda,
				filter,
			})
		}
	} catch (e) {
		ctx.commit(EVENT_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(EVENT_MY_AGENDA_LOADING_STATUS, { value: false })
	}
}

const voteEventPolls = async (ctx, { answers, eventId, sessionId }) => {
	try {
		ctx.commit(EVENT_POLLS_LOADING_STATUS, true)
		for (const [index, answer] of answers.entries()) {
			const pollAnswer = { poll_id: answer.poll_id }
			if (answer.poll_answer_id && answer.poll_answer_id.length) {
				pollAnswer.poll_answer_id = answer.poll_answer_id
			}
			if (answer.custom_answer && answer.custom_answer.length) {
				pollAnswer.custom_answer = answer.custom_answer
			}
			await event.voteEventPoll(pollAnswer)
			if (index + 1 === answers.length) {
				if (eventId) {
					const query = {
						expand: 'polls,is_attendees_available,is_agenda_available,speakersList,partner_groups,eventActions',
					}
					const { data } = await event.getEvent(eventId, query)
					ctx.commit(UPDATE_EVENT_POLLS, data.polls)
				} else if (sessionId) {
					const { data } = await event.getEventSession(sessionId)
					ctx.commit(SESSION_EVENT_GET, data)
				}
			}
		}
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_POLLS_LOADING_STATUS, false)
	}
}

const getEventSpeakersById = async (ctx, query) => {
	try {
		ctx.commit(EVENT_LOADING_STATUS, true)
		const { data, headers } = await event.getEventSpeakersById(query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(EVENT_SPEAKERS_GET, response)
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const clearEventSpeakers = async (ctx) => {
	try {
		ctx.commit(EVENT_SPEAKERS_CLEAR)
	} catch (e) {
		console.log(e)
	}
}

const voteEventRatings = async (ctx, { ratings, eventId }) => {
	try {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, true)
		for (const [index, rating] of ratings.entries()) {
			await event.voteEventRating({ ...rating, event_id: eventId })
			if (index + 1 === ratings.length) {
				const query = {
					expand: 'polls,is_attendees_available,is_agenda_available,speakersList,partner_groups,eventActions,ratings',
				}
				const { data } = await event.getEvent(eventId, query)
				ctx.commit(UPDATE_EVENT_RATINGS, data.ratings)
			}
		}
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, false)
	}
}

const voteSessionRatings = async (ctx, { ratings, sessionId }) => {
	try {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, true)
		for (const [index, rating] of ratings.entries()) {
			await event.voteSessionRating({ ...rating, agenda_id: sessionId })
			if (index + 1 === ratings.length) {
				const { data } = await event.getEventSession(sessionId)
				ctx.commit(UPDATE_SESSION_RATINGS, data.ratings)
			}
		}
	} catch (e) {
		console.log(e)
	} finally {
		ctx.commit(EVENT_RATINGS_LOADING_STATUS, false)
	}
}

const getExhibitorById = async (ctx, { id, groupId }) => {
	try {
		ctx.commit(EVENT_LOADING_STATUS, true)
		const { data } = await event.getExhibitorById(id, groupId)
		ctx.commit(EVENT_GET_EXHIBITOR, data)
	} catch (e) {
		ctx.commit(EVENT_GET_EXHIBITOR_ERROR, e)
		console.log(e)
	} finally {
		ctx.commit(EVENT_LOADING_STATUS, false)
	}
}

const clearExhibitor = async (ctx) => {
	try {
		ctx.commit(EVENT_CLEAR_EXHIBITOR)
	} catch (e) {
		console.log(e)
	}
}

export default {
	getEvent,
	getAgendaEvent,
	fetchEvents,
	fetchPartners,
	getAttendeesEvent,
	fetchEventCategories,
	clearAttendeesEvent,
	getAttendee,
	getSession,
	clearSession,
	getActionFiles,
	getActionLinks,
	addSessionQuestion,
	getSessionQuestions,
	upvoteSessionQuestion,
	deleteUpvoteSessionQuestion,
	clearEventCategories,
	addEventToSchedule,
	removeEventFromSchedule,
	getEventTracks,
	clearEventTracks,
	addMyAgenda,
	removeMyAgenda,
	voteEventPolls,
	getEventSpeakersById,
	clearEventSpeakers,
	voteEventRatings,
	voteSessionRatings,
	getExhibitorById,
	toggleBookmark,
	saveFollowNote,
	getBoothStaff,
	postRegisterSession,
	deleteRegisterSessions,
	clearExhibitor,
	getEventPrivate,
	getSubSessions,
	getAllSessionsSpeaker,
	deleteSessionQuestion,
	getEventSurvey,
	postSurvey,
	postNextStep,
	postBackStep,
    getPartnerFiles,
    getGiveaways,
    getSurveyErrorClear
}
